import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CustomDatePicker from "../utils/CustomDatePicker";

const EditFieldDialog = ({ open, onClose, field, label, value, onSave }) => {
  const { t } = useTranslation();
  const [newValue, setNewValue] = React.useState(value);

  React.useEffect(() => {
    setNewValue(value);
  }, [value]);

  const handleSave = () => {
    onSave(field, newValue);
    onClose();
  };

  return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle> {t('update') + ": " + label}</DialogTitle>
        <DialogContent sx={{ paddingTop: "16px" }}>
          {field.includes("Date") ? (
            <CustomDatePicker
              value={newValue}
              onChange={(newDate) => setNewValue(newDate)}
              gridSize={12} 
              gridSx={{ width: "350px" }}
            />
          ) : field === "carrier" ? (
            <Select
              label={label}
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              fullWidth
              margin="dense"
            >
              <MenuItem value="Area Time">Area Time</MenuItem>
              <MenuItem value="GoPak">GoPak</MenuItem>
              <MenuItem value="Marken">Marken</MenuItem>
              <MenuItem value="QuickSTAT">QuickSTAT</MenuItem>
              <MenuItem value="Transcourrier">Transcourrier</MenuItem>
            </Select>
          ) : (
            <TextField
              label={label}
              value={newValue}
              onChange={(e) => setNewValue(e.target.value)}
              fullWidth
              margin="dense"
              InputLabelProps={{ style: { whiteSpace: "nowrap" } }}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="outlined" color="secondary">{t("cancel")}</Button>
          <Button onClick={handleSave} variant="contained" color="primary">
            {t("save")}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default EditFieldDialog;
